/* IT HIPPIE - bloc promo newsletter du tiroir.
   VERSION NATIVE : le formulaire se soumet réellement vers /contact, exactement
   comme le formulaire newsletter du footer. Plus aucun POST en AJAX :
   si Shopify déclenche un captcha, il s'affiche et l'inscription aboutit quand même.
 
   Ce script ne gère plus que :
   1. L'accordéon du bloc.
   2. Au submit : mémorisation de l'email + application du code promo
      (fetch keepalive : la requête survit à la navigation).
   3. Au retour (?customer_posted=true) : marque l'inscription comme faite
      et affiche la confirmation dans le bloc.
   4. Pré-remplissage de l'email au checkout via permalien de panier.
   5. Masquage du bloc pour les clientes déjà inscrites. */
(function () {
  if (window.__ithPromoBound) return;
  window.__ithPromoBound = true;
 
  function getCode() {
    var box = document.getElementById('cart-promo-newsletter');
    return (box && box.dataset.code) ? box.dataset.code : 'HELLO10';
  }
 
  function applyPromoState() {
    var done = false;
    var posted = false;
    try {
      done = localStorage.getItem('ithippie_promo_done') === '1';
      posted = localStorage.getItem('ithippie_promo_posted') === '1';
    } catch (e) {}
    var box = document.getElementById('cart-promo-newsletter');
    if (!box) return;
 
    /* Retour d'inscription : on montre la confirmation au lieu du formulaire */
    if (posted) {
      var form = document.getElementById('cart-promo-form') || box.querySelector('form');
      var confirmEl = document.getElementById('cart-promo-confirm');
      box.classList.add('is-open');
      if (form) form.style.display = 'none';
      if (confirmEl) confirmEl.style.display = 'flex';
      box.style.display = '';
      return;
    }
 
    box.style.display = done ? 'none' : '';
  }
 
  // Clics : accordéon OU bouton Commander (pré-remplissage email)
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
 
    var toggle = e.target.closest('#cart-promo-toggle');
    if (toggle) {
      var box = document.getElementById('cart-promo-newsletter');
      if (!box) return;
      var open = box.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var inp = document.getElementById('cart-promo-email'); if (inp) setTimeout(function () { inp.focus(); }, 60); }
      return;
    }
 
    var checkoutBtn = e.target.closest('cart-drawer button[name="checkout"]');
    if (checkoutBtn) {
      var savedEmail = '';
      try { savedEmail = localStorage.getItem('ithippie_promo_email') || ''; } catch (err) {}
      var isLoggedIn = document.documentElement.hasAttribute('data-customer-logged-in');
      if (savedEmail && !isLoggedIn) {
        e.preventDefault();
        e.stopPropagation();
        goToCheckoutWithEmail(savedEmail);
      }
      /* sinon : comportement normal du bouton */
    }
  });
 
  /* Au submit (natif, on ne bloque RIEN) : on mémorise l'email et on applique
     le code promo. keepalive: true permet à la requête de partir même si la
     page navigue immédiatement après. */
  document.addEventListener('submit', function (e) {
    var form = (e.target && e.target.closest) ? e.target.closest('form') : null;
    if (!form || !form.closest('#cart-promo-newsletter')) return;
 
    var inp = document.getElementById('cart-promo-email');
    var email = inp ? inp.value.trim() : '';
    try {
      if (email) localStorage.setItem('ithippie_promo_email', email);
      localStorage.setItem('ithippie_promo_pending', '1');
    } catch (err) {}
 
    try {
      fetch('/discount/' + encodeURIComponent(getCode()), { keepalive: true, headers: { 'Accept': 'text/html' } }).catch(function () {});
    } catch (err) {}
    /* PAS de preventDefault : la soumission native continue, comme le footer */
  });
 
  /* Pré-remplissage de l'email au checkout via permalien de panier
     (/cart/VARIANT:QTE,...?checkout[email]=...), seule méthode supportée par Shopify.
     Le code promo posé en cookie reste appliqué. */
  function goToCheckoutWithEmail(email) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) {
          window.location.href = '/checkout';
          return;
        }
        var parts = cart.items.map(function (it) { return it.variant_id + ':' + it.quantity; });
        window.location.href = '/cart/' + parts.join(',') + '?checkout[email]=' + encodeURIComponent(email);
      })
      .catch(function () {
        window.location.href = '/checkout';
      });
  }
 
  function init() {
    /* Retour d'une soumission réussie : Shopify renvoie sur la page avec ?customer_posted=true */
    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      var pending = false;
      try { pending = localStorage.getItem('ithippie_promo_pending') === '1'; } catch (e) {}
      if (pending) {
        try {
          localStorage.setItem('ithippie_promo_done', '1');
          localStorage.setItem('ithippie_promo_posted', '1');
          localStorage.removeItem('ithippie_promo_pending');
        } catch (e) {}
        /* filet de sécurité : ré-applique le code au cas où le keepalive n'est pas passé */
        try {
          fetch('/discount/' + encodeURIComponent(getCode()), { headers: { 'Accept': 'text/html' } }).catch(function () {});
        } catch (e) {}
        /* on rouvre le tiroir pour montrer la confirmation "Code activé" */
        setTimeout(function () {
          var dr = document.querySelector('cart-drawer');
          if (dr && typeof dr.open === 'function') { try { dr.open(); } catch (e) {} }
        }, 400);
      }
    }
    applyPromoState();
    var dr = document.querySelector('cart-drawer') || document.body;
    if (window.MutationObserver) {
      new MutationObserver(function () { applyPromoState(); }).observe(dr, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('cart:refresh', applyPromoState);
})();